// extracted by mini-css-extract-plugin
module.exports = {"credible3Container":"QIm0HOL5","homes1Container":"_3Gy6oy0p","fox1Container":"_3py_9JkY"};